import { render, staticRenderFns } from "./SteamIdOnboarding.vue?vue&type=template&id=63c51bbc&scoped=true&"
import script from "./SteamIdOnboarding.vue?vue&type=script&lang=js&"
export * from "./SteamIdOnboarding.vue?vue&type=script&lang=js&"
import style0 from "./SteamIdOnboarding.vue?vue&type=style&index=0&id=63c51bbc&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c51bbc",
  null
  
)

component.options.__file = "SteamIdOnboarding.vue"
export default component.exports